import React, { FC } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';

export interface ActionArrowProps {
  right?: number;
  top?: number;
  stylesToReplace?: StyleProp<ViewStyle>;
}

export const ActionArrow: FC<ActionArrowProps> = ({ right = 16, top = 16, stylesToReplace }) => {
  return (
    <View style={stylesToReplace ?? { position: 'absolute', right: scale(right), top: scale(top) }}>
      <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
    </View>
  );
};
